import { Component, OnInit, Input, NgModule } from '@angular/core';
import * as nav_const from '../../app-navigation';
import { Router, NavigationEnd } from '@angular/router';
import { Auth0Service } from 'src/app/auth/auth0.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import {
  BUYER_SOFT_LAUNCH_PARTICIPANTS,
  SELLER_SOFT_LAUNCH_PARTICIPANTS,
  StorageType,
} from 'src/app/shared/models/constants';
import { ScreenService } from 'src/app/shared/services/screen.service';
import { SideNavigationMenuModule } from '../side-navigation-menu/side-navigation-menu.component';
import { DxDrawerModule, DxScrollViewModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { MedigiClickwrapModule } from 'src/app/shared/components/medigi-clickwrap/medigi-clickwrap.module';
import { HeaderModule } from '../header/header.component';
import { UserService } from 'src/app/shared/services/user/user.service';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import _ from 'lodash';
import { FeatureFlagsService } from 'src/app/shared/services/featureFlags.service';
import {
  CatalogConfigurations,
  CatalogConfigurationsService,
} from 'src/app/shared/services/catalog-configurations.service';
import { MenuService } from 'src/app/shared/services/menu.service';

@Component({
  selector: 'app-side-nav-outer-toolbar',
  templateUrl: './side-nav-outer-toolbar.component.html',
  styleUrls: ['./side-nav-outer-toolbar.component.scss'],
})
export class SideNavOuterToolbarComponent implements OnInit {
  menuItems = [];
  selectedRoute = '';

  menuOpened: boolean;
  cartOpened: boolean;
  showClickwrap: boolean;
  temporaryMenuOpened = false;

  @Input() title: string;

  menuMode = 'shrink';
  menuRevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;

  user: any;
  medigiAdmin = false;
  catalogConfigurations: CatalogConfigurations = null;

  constructor(
    private screen: ScreenService,
    public auth0: Auth0Service,
    private router: Router,
    private userService: UserService,
    private storageService: StorageService,
    private featureFlagsService: FeatureFlagsService,
    public catalogConfigsService: CatalogConfigurationsService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private menuService: MenuService,
  ) {}

  ngOnInit() {
    this.menuService.menuItems$.subscribe(items => {
      this.menuItems = items;
    });

    this.menuService.userInfo$.subscribe(info => {
      if (info) {
        this.user = info.user;
        this.medigiAdmin = info.medigiAdmin;
      }
    });

    this.getCatalogConfigs();
    this.menuService.updateMenu(this.menuOpened);

    this.storageService.watch().subscribe((data: string) => {
      if (data === StorageType.session) {
        this.menuService.updateMenu(this.menuOpened);
      }
    });

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split('?')[0];
      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isSmall = this.screen.sizes['screen-small'];
    const isLarge = this.screen.sizes['screen-large'];
    this.minMenuSize = isXSmall || isSmall ? 0 : 60;
    this.menuOpened = isLarge;
    this.menuService.updateMenu(this.menuOpened);
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  async navigationChanged(event) {
    let path = event.itemData.path;
    const pointerEvent = event.event;

    if (event.itemData.externalUrl) {
      window.open(event.itemData.externalUrl, '_blank', 'noopener');
      pointerEvent.preventDefault();
      return;
    }

    if (path) {
      if (path === '/medigi') {
        this.showClickwrapOrRedirect();
        return;
      }

      path = this.processCatalogRedirect(path);
      this.router.navigate([path]);

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent.stopPropagation();
      }
    } else {
      pointerEvent.preventDefault();
    }

    if (event.node.children.length !== 0) {
      this.menuOpened = true;
    }
  }

  showClickwrapOrRedirect() {
    if (!this.user.company.agreed_to_medigi) {
      this.showClickwrap = true;
    } else {
      window.location.href = `${location.protocol}//${environment.clientDomains.medigiDomain}/catalog`;
    }
  }

  processCatalogRedirect(path: any) {
    if (path === '/catalog') {
      return this.resetCatalog('503b|medigi|medshorts', false);
    }
    if (path === '/catalog/1/0/0') {
      return this.resetCatalog('medshorts', false);
    }
    if (path === '/catalog/0/1/0') {
      return this.resetCatalog('medigi', false);
    }
    if (path === '/catalog/0/0/1') {
      return this.resetCatalog('503b', false);
    }
    return path;
  }

  private resetCatalog(catalogType: string, searchFlag: boolean) {
    this.catalogConfigsService.reset(false);
    this.catalogConfigurations.catalogTypes.search503bFlag = searchFlag;
    this.catalogConfigurations.catalogTypes.searchMedshortsFlag = searchFlag;
    this.catalogConfigurations.catalogTypes.searchMedigiFlag = searchFlag;
    this.catalogConfigsService.setCatalogType(catalogType, true);
    this.catalogConfigsService.search();
    return '/catalog';
  }

  getCatalogConfigs() {
    this.catalogConfigsService.get().subscribe(result => {
      this.catalogConfigurations = result;
    });
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}

@NgModule({
  imports: [
    SideNavigationMenuModule,
    DxDrawerModule,
    HeaderModule,
    DxScrollViewModule,
    CommonModule,
    MedigiClickwrapModule,
  ],
  exports: [SideNavOuterToolbarComponent],
  declarations: [SideNavOuterToolbarComponent],
})
export class SideNavOuterToolbarModule {}
